import { useMutation } from '@apollo/client';

import AddVerifiableFieldMutation from '@/graphql/contracts/addVerifiableField.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  AddVerifiableField,
  AddVerifiableFieldVariables
} from '@/graphql/contracts/_generated_/addVerifiableField.mutation';
import { notificationService } from '@/services/notification/notification.client';

export type AddVerifiableFieldDto = AddVerifiableFieldVariables;

export function useAddVerifiableField() {

  const [_addVerifiableField, { loading }] = useMutation<AddVerifiableField, AddVerifiableFieldVariables>(
    AddVerifiableFieldMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  const addVerifiableField = (dto: AddVerifiableFieldDto, onSuccess?: () => void) => {
    _addVerifiableField({
      variables: dto,
      refetchQueries: ['GetVerifiableFields'],
      onCompleted: () => {
        notificationService.open({
          title: 'Verifiable Field',
          text: 'Field successfully added',
          type: 'success',
        });

        onSuccess?.();
      },
    });
  };

  return {
    addVerifiableField,
    isLoading: loading,
  } as const;
}
